import { render, staticRenderFns } from "./RatingConfigForm.vue?vue&type=template&id=1563db6e&"
import script from "./RatingConfigForm.vue?vue&type=script&lang=js&"
export * from "./RatingConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports